/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleDto } from '../../models/schedule-dto';

export interface ScheduleGetScheduleById$Json$Params {
  scheduleId: string;
}

export function scheduleGetScheduleById$Json(http: HttpClient, rootUrl: string, params: ScheduleGetScheduleById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, scheduleGetScheduleById$Json.PATH, 'get');
  if (params) {
    rb.path('scheduleId', params.scheduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleDto>;
    })
  );
}

scheduleGetScheduleById$Json.PATH = '/api/Schedule/{scheduleId}';
